import { createContext } from "react"

export interface ScientificDayInterface {
  _id: any, 
  theme: string,
  RegFees: string,
  images: string[]
  createdAt: string,
}

export const DefaultScientificDayInterface: ScientificDayInterface = {
  _id: "",
  theme: "",
  RegFees: "",
  images: [""],
  createdAt: "",
}

export interface ShowScientificDayInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddScientificDayModal: boolean, setShowAddScientificDayModal: (showAddScientificDayModal: boolean) => void,
  showEditScientificDayModal: boolean, setShowEditScientificDayModal: (showEditScientificDayModal: boolean) => void,
  showDeleteScientificDayModal: boolean, setShowDeleteScientificDayModal: (showDeleteScientificDayModal: boolean) => void,
  selectedScientificDay: ScientificDayInterface, setSelectedScientificDay: (selectedScientificDay: ScientificDayInterface) => void,
  selectedModal: string, setSelectedModal: (selectedModal: string) => void,
  showDeleteScientificDayPhotoModal: boolean, setShowDeleteScientificDayPhotoModal: (showDeleteScientificDayPhotoModal: boolean) => void,
  selectedPhoto: string, setSelectedPhoto: (selectedPhoto: string) => void,
}

export const DefaultShowScientificDayInterface: ShowScientificDayInterface = {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
  showAddScientificDayModal: false, setShowAddScientificDayModal: () => {},
  showEditScientificDayModal: false, setShowEditScientificDayModal: () => {},
  showDeleteScientificDayModal: false, setShowDeleteScientificDayModal: () => {},
  selectedScientificDay: DefaultScientificDayInterface, setSelectedScientificDay: () => {},
  selectedModal: "", setSelectedModal: () => {},
  showDeleteScientificDayPhotoModal: false, setShowDeleteScientificDayPhotoModal: () => {},
  selectedPhoto: "", setSelectedPhoto: () => {},
}

export const ShowScientificDayContext = createContext<ShowScientificDayInterface>(DefaultShowScientificDayInterface)

export interface FormDataScientificDayInterface {
  theme: string, setTheme: (theme: string) => void,
  RegFees: string, setRegFees: (RegFees: string) => void,
  createdAt: string, setCreatedAt: (createdAt: string) => void,
  images: File[] | any, setImages: (images: File[] | any) => void,
}

export const DefaultFormDataScientificDayInterface: FormDataScientificDayInterface = {
  theme: "", setTheme: () => {},
  RegFees: "", setRegFees: () => {},
  createdAt: "", setCreatedAt: () => {},
  images: null, setImages: () => {},
}

export const FormDataScientificDayContext = createContext<FormDataScientificDayInterface>(DefaultFormDataScientificDayInterface)

export enum modalType {
  AddModal = "AddModal",
  EditModal = "EditModal",
  DeleteModal = "DeleteModal",
}

